import { render, staticRenderFns } from "./ProductBanners.vue?vue&type=template&id=00e12336&"
import script from "./ProductBanners.vue?vue&type=script&lang=js&"
export * from "./ProductBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports